import React from 'react';

interface MultiSelectNoticeProps {
    visible: boolean;
}

const MultiSelectNotice: React.FC<MultiSelectNoticeProps> = ({ visible }) => {
    if (!visible) return null;

    return (
        <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(255, 255, 255, 0.85)',
            zIndex: 999,
            color: '#333',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            textAlign: 'center',
            padding: '2rem',
            minHeight: '400px'
        }}>
            <div style={{ fontSize: '4rem', color: '#cc0000', marginBottom: '1rem' }}>&#9888;</div>
            <div style={{ fontSize: '1.125rem', fontWeight: 'bold', color: '#333', fontFamily: 'Segoe UI, sans-serif' }}>Aggregate site data not available</div>
        </div>
    );
};

export default MultiSelectNotice;
